module.exports = __webpack_public_path__ + "img/applet_QRcode.c492e031.jpg";